<template>
  <KITSCombo
    propertyName="Value"
    propertyID="Key"
    v-bind:items="items"
    v-on:input="inputEvent"
    :value="item"
  ></KITSCombo>
</template>

<script>
import KITSCombo from "fwkits-core-presentation-vue/components/Editors/KITSCombo";

export default {
  name: "RapiPagoCombo",
  components: { KITSCombo },
  props: {
    selectedvalue: Number,
    item: Object,
    name: String
  },
  data() {
    return {
      items: [],
      itemSelect:null
    };
  },
  methods: {
    inputEvent(val) {
      this.$emit("update:selectedvalue", val);
    }
  },
  beforeMount: function() {
    this.items = Object.keys(this.item).reduce((acc, curr) => {
      //acc.push(`${curr} - ${item[curr]}`);
      acc.push({ Key: curr, Value: this.item[curr] });
      return acc;
    }, []);
  }
};
</script>